import { getMessages } from '../../../../../store/constants';

export const TUTORIALS_BUTTON_FINISH = getMessages().getText('tutorials.button.finish');
export const TUTORIALS_BUTTON_NEXT = getMessages().getText('tutorials.button.next');
export const TUTORIALS_BUTTON_PREVIOUS = getMessages().getText('tutorials.button.previous');
export const TUTORIALS_BUTTON_SKIP = getMessages().getText('tutorials.button.skip');
